import { render, staticRenderFns } from "./LearningMaterialSlider.vue?vue&type=template&id=e9930aca"
import script from "./LearningMaterialSlider.vue?vue&type=script&lang=js"
export * from "./LearningMaterialSlider.vue?vue&type=script&lang=js"
import style0 from "./LearningMaterialSlider.vue?vue&type=style&index=0&id=e9930aca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports